import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the B03D02ReportFullPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b03-d02-report-full',
  templateUrl: 'b03-d02-report-full.html',
})
export class B03D02ReportFullPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B03D02ReportFullPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/b03-d02-report-full/b03-d02-report-full.ts